import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES,
    UPDATE_PAYMENT_METHOD
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, get, update, push } from "firebase/database";

export const fetchPaymentMethods = () => (dispatch) => {

    const {
      config,
      paymentSettingsRef
    } = firebase;
  
    const profile = store.getState().auth.profile;
    // Mismo delay en AppCommon que fetchCars: sin perfil (logout) no leer .usertype.
    if (!profile?.usertype) {
      return;
    }
    const usertype = profile.usertype;

    dispatch({
      type: FETCH_PAYMENT_METHODS,
      payload: null
    });

    if(usertype == 'admin'){
        onValue(paymentSettingsRef, snapshot => {
            const data = snapshot.val(); 
            if(data){
              dispatch({
                type: FETCH_PAYMENT_METHODS_SUCCESS,
                payload: data
              });
            } else {
              dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.no_provider_found,
              });
            }
          });
    } else { 
        const settings = store.getState().settingsdata.settings;
        let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
        let url = `${host}/get_providers`;
        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.length > 0) {
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_SUCCESS,
                        payload: responseJson,
                    });
                }else{
                    dispatch({
                        type: FETCH_PAYMENT_METHODS_FAILED,
                        payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: FETCH_PAYMENT_METHODS_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.provider_fetch_error + ": " + error.toString(),
                });
            });
    }
  };

  export const editPaymentMethods = (data) => (dispatch) => {
    const {
        paymentSettingsRef
    } = firebase;
    dispatch({
      type: UPDATE_PAYMENT_METHOD,
      payload: data 
    });
    update(paymentSettingsRef, data);
  }
  


export const clearMessage = () => (dispatch) => {
    dispatch({
        type: CLEAR_PAYMENT_MESSAGES,
        payload: null,
    });    
};


/** Único correo autorizado para recargas manuales de billetera (la función del servidor también lo exige). */
export const WALLET_CREDIT_ADMIN_EMAIL = 'advancedtechnologyapps@gmail.com';

export const canAuthorizeWalletCredit = (profile) =>
    !!profile &&
    profile.usertype === 'admin' &&
    String(profile.email || '').trim().toLowerCase() === WALLET_CREDIT_ADMIN_EMAIL;

export const newWalletCreditRequestId = () =>
    Date.now().toString(36) + Math.random().toString(36).slice(2, 12);

/** Recarga manual: la valida y aplica la Cloud Function admin_add_to_wallet. */
export const adminAddToWallet = async ({ uid, amount, note, requestId }) => {
    const { auth, config } = firebase;
    const settings = store.getState().settingsdata.settings;
    const host =
        window && window.location && settings.CompanyWebsite === window.location.origin
            ? window.location.origin
            : `https://${config.projectId}.web.app`;
    try {
        const idToken = await auth.currentUser.getIdToken();
        const response = await fetch(`${host}/admin_add_to_wallet`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${idToken}`,
            },
            body: JSON.stringify({ uid, amount, note, requestId }),
        });
        const result = await response.json();
        if (result.success) return result;
        return { success: false, error: result.error || 'No se pudo completar la recarga.' };
    } catch (error) {
        return { success: false, network: true, error: 'No se pudo contactar al servidor. Revisa tu conexión e intenta de nuevo.' };
    }
};

export const fetchWalletAdminCredits = async (limit = 100) => {
    const { walletAdminCreditsRef } = firebase;
    const snapshot = await get(walletAdminCreditsRef);
    const data = snapshot.val() || {};
    return Object.keys(data)
        .map((id) => ({ ...data[id], id }))
        .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
        .slice(0, limit);
};


export const withdrawBalance = (profile, amount) => async (dispatch) => {

    const {
        withdrawRef,
    } = firebase;
    
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    push(withdrawRef, {
        uid : profile.uid,
        name : profile.firstName +  ' ' + profile.lastName,
        amount : parseFloat(amount),
        date : new Date().getTime(),
        bankName : profile.bankName? profile.bankName : '',
        bankCode : profile.bankCode? profile.bankCode : '',
        bankAccount : profile.bankAccount? profile.bankAccount : '',
        processed:false
    }).catch((error) => {
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: error.code + ": " + error.message,
        });
    });
       
};
